export enum ProductSource {
  Shopify = "shopify",
  Bigcommerce = "bigcommerce",
  Commentsold = "commentsold",
  CommerceCloud = "commerce-cloud",
  Cin7Omni = "cin7-omni",
  Cin7Core = "cin7-core",
  Amazon = "amazon",
  Ebay = "ebay",
}
